// src/config/productionStatuses.js

export const PRODUCTION_STATUS_CONFIG = {
  REVISAO: {
    label: "REVISÃO",
    color: "bg-yellow-200 text-yellow-800 border-yellow-300 shadow-sm",
  },
  PEDIDO_MODIFICADO: {
    label: "PEDIDO MODIFICADO",
    color: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-300 animate-pulse",
  },
  SOLICITACAO: {
    label: "AGUARDANDO ANÁLISE",
    color: "bg-slate-600 text-white border-slate-700",
  },
  GRAVACAO: {
    label: "GRAVAÇÃO",
    color: "bg-orange-400 text-white border-orange-500",
  },
  MODELAGEM: {
    label: "MODELAGEM",
    color: "bg-pink-300 text-pink-900 border-pink-400",
  },
  // --- CORREÇÃO AQUI: Era FALTA_BANCA, agora é FALHA_BANCA ---
  FALHA_BANCA: {
    label: "FALHA BANCA",
    color: "bg-red-500 text-white border-red-600",
  },
  // -----------------------------------------------------------
  IMPRIMIR: {
    label: "IMPRIMIR",
    color: "bg-emerald-500 text-white border-emerald-600",
  },
  PEDIDO_PRONTO: {
    label: "PEDIDO PRONTO",
    color: "bg-green-600 text-white border-green-700",
  },
  CANCELADO: {
    label: "CANCELADO",
    color: "bg-gray-700 text-gray-300 border-gray-800",
  },
  CURA: { label: "CURA", color: "bg-purple-600 text-white border-purple-700" },
  INJETADO: {
    label: "INJETADO",
    color: "bg-amber-600 text-white border-amber-700 shadow-sm",
  },
  RESINA_FINALIZACAO: {
    label: "RESINA/FINALIZAÇÃO",
    color: "bg-blue-400 text-white border-blue-500",
  },
  VERIFICAR: {
    label: "VERIFICAR",
    color: "bg-pink-400 text-white border-pink-500",
  },
  INTERCEPTADO_FABRICA_ESTOQUE: {
    label: "INTERCEPTADO DA FÁBRICA DE ESTOQUE",
    color: "bg-indigo-700 text-white border-indigo-800",
  },
  IMPRIMINDO: {
    label: "IMPRIMINDO",
    color: "bg-orange-500 text-white border-orange-600",
  },
  BANHO: { label: "BANHO", color: "bg-cyan-600 text-white border-cyan-700" },
  IR_PARA_BANCA: {
    label: "IR PARA BANCA",
    color: "bg-stone-600 text-white border-stone-700",
  },
  FUNDICAO: {
    label: "FUNDIÇÃO",
    color: "bg-teal-400 text-teal-900 border-teal-500",
  },
  ACABAMENTO_EXTERNO: {
    label: "ACABAMENTO EXTERNO",
    color: "bg-indigo-400 text-white border-indigo-500",
  },
  POLIMENTO: {
    label: "POLIMENTO",
    color: "bg-yellow-600 text-white border-yellow-700",
  },
  ENVIADO: {
    label: "ENVIADO",
    color: "bg-stone-500 text-white border-stone-600",
  },
  INTERCEPTADO_ESTOQUE: {
    label: "INTERCEPTADO DO ESTOQUE",
    color: "bg-blue-700 text-white border-blue-800",
  },
  BANCA: { label: "BANCA", color: "bg-lime-500 text-lime-900 border-lime-600" },
  MANUTENCAO: {
    label: "AJUSTE/MANUTENÇÃO",
    color: "bg-sky-400 text-white border-sky-500",
  },
  FALTA_PEDRA: {
    label: "FALTA PEDRA",
    color: "bg-purple-400 text-purple-900 border-purple-500",
  },
};

// Ordem do Kanban (Usado na Produção)
export const KANBAN_ORDER = [
  "REVISAO",
  "PEDIDO_MODIFICADO",
  "GRAVACAO",
  "MANUTENCAO",
  "FALHA_BANCA", // <--- CORRIGIDO AQUI TAMBÉM (Era FALTA_BANCA)
  "VERIFICAR",
  "SOLICITACAO",
  "IMPRIMIR",
  "IMPRIMINDO",
  "CURA",
  "INJETADO", // <--- Peças de cera injetadas aguardando montagem da árvore de fundição
  "FUNDICAO",
  "INTERCEPTADO_ESTOQUE",
  "INTERCEPTADO_FABRICA_ESTOQUE",
  "ACABAMENTO_EXTERNO",
  "BANCA",
  "POLIMENTO",
  "RESINA_FINALIZACAO",
  "PEDIDO_PRONTO",
  "CANCELADO",
  "MODELAGEM",
];

export const DAYS_COLUMNS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// Status elegíveis para o novo fluxo de injeção de molde de borracha
// Só se aplica a pedidos em etapas iniciais/pré-impressão/impressão:
// VERIFICAR, AGUARDANDO ANÁLISE (SOLICITACAO), IMPRIMIR e IMPRIMINDO.
// Depois disso (Fundição, Banca, etc.), o pedido obedece o fluxo normal dos outros pedidos.
export const STATUSES_MOLDE_INJECAO = [
  "VERIFICAR",
  "SOLICITACAO",
  "IMPRIMIR",
  "IMPRIMINDO"
];

export const isStatusAguardandoInjecao = (status) => {
  if (!status) return false;
  const s = String(status).trim().toUpperCase();
  return (
    STATUSES_MOLDE_INJECAO.includes(s) ||
    s === "AGUARDANDO ANÁLISE" ||
    s === "AGUARDANDO ANALISE"
  );
};

// Retorna true se o pedido estiver em qualquer fase de cera/molde (pré-injeção ou injetado aguardando árvore)
export const isStatusFaseCeraMolde = (status) => {
  if (!status) return false;
  const s = String(status).trim().toUpperCase();
  return isStatusAguardandoInjecao(s) || s === "INJETADO";
};
